import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

import { UiIconsList, UiIconsModule } from 'ui-icons';

import { UiPlatformDropdownTriggerType, UiPlatformMenuItem, UiPlatformMenuItems } from './menu.model';

import { UiPlatformButtonType } from '../button/button.model';

@Component({
  selector: 'ui-platform-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    NgIf,
    NgFor,
    NgTemplateOutlet,
    UiIconsModule,
    NzButtonModule,
    NzDropDownModule,
    TranslocoPipe
  ]
})
export class UiPlatformMenuComponent {
  @Input() label = '';
  @Input() type: UiPlatformButtonType = 'primary';
  @Input() icon: UiIconsList | undefined;
  @Input() iconPlacement: 'left' | 'right' = 'left';
  @Input() textSize: 'standard' | 'smaller' = 'standard';
  @Input() disabled = false;
  @Input() inProgress = false;
  @Input() chevron = false;
  @Input() triggerMode: UiPlatformDropdownTriggerType = 'hover';
  @Input() menuItems: UiPlatformMenuItems = [];
  @Input() lighterIcon = false;
  @Input() callbackData?: any;

  @Output() openMenuTrigger: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() menuItemClick: EventEmitter<UiPlatformMenuItem> = new EventEmitter<UiPlatformMenuItem>();

  get classList() {
    const classes: string[] = [];
    classes.push(`ant-btn-${this.type}`);

    // special handling if we have only icon with no text - the padding is smaller
    if (this.label === '' || this.label === undefined || this.label === null) {
      classes.push('sh-btn-padding-smaller');
    }

    if (this.textSize === 'smaller') {
      classes.push('sh-btn-font-smaller');
    }

    return classes;
  }

  get iconKey() {
    return this.icon as UiIconsList;
  }

  get hasLighterIcon() {
    return this.lighterIcon;
  }

  get nzType() {
    if (this.type === 'secondary') {
      return 'default';
    }

    if (this.type === 'text' || this.type === 'link') {
      return this.type;
    }

    if ([
        'text-primary',
        'text-paragraph',
        'text-primary-paragraph'
      ].includes(this.type)) {
      return 'text';
    }

    return 'primary';
  }

  menuItemSelected(item: UiPlatformMenuItem) {
    if (item.callback) {
      item.callback(item.callbackParams ?? this.callbackData);
    }

    this.menuItemClick.emit(item);
  }

  onOpenMenuTrigger(menuOpen: boolean): void {
    this.openMenuTrigger.emit(menuOpen);
  }
}
